import React from 'react'
import styled from 'styled-components'
import { IPalletDetails } from '../../../../modules/API/Pallets/models/palletDetails'
import CardFlat from '../../../ui/card-flat/CardFlat'
import { IPalletGroup } from '../hooks/useEntryPallets'
import PalletDetailRow from './PalletDetailRow'

type Props = {
  group: IPalletGroup
  onRowClick: (detail: IPalletDetails) => void
}

const PalletGroupCard = ({ group, onRowClick }: Props) => {
  const showDelivery = group.deliveryNum !== 0 || group.deliverySub !== 0

  return (
    <CardFlat.Root>
      <CardFlat.Row>
        <CardFlat.Item>
          <CardFlat.ItemLabel>משטח</CardFlat.ItemLabel>
          <CardFlat.ItemValue>{group.palletNum}</CardFlat.ItemValue>
        </CardFlat.Item>
        {group.customerName.trim() ? (
          <CardFlat.Item>
            <CardFlat.ItemLabel>לקוח</CardFlat.ItemLabel>
            <CardFlat.ItemValue>{group.customerName.trim()}</CardFlat.ItemValue>
          </CardFlat.Item>
        ) : null}
        {showDelivery ? (
          <CardFlat.Item>
            <CardFlat.ItemLabel>תעודה</CardFlat.ItemLabel>
            <CardFlat.ItemValue>
              {group.deliveryNum}-{group.deliverySub}
            </CardFlat.ItemValue>
          </CardFlat.Item>
        ) : null}
      </CardFlat.Row>
      <CardFlat.Divider />
      <ItemsList>
        {group.items.map((detail) => (
          <PalletDetailRow key={detail.RecID} detail={detail} onRowClick={onRowClick} />
        ))}
      </ItemsList>
    </CardFlat.Root>
  )
}

const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15em;
`

export default PalletGroupCard
